import axios from 'axios'
import { getMemoryAccessToken, setMemoryAccessToken, clearMemoryAccessToken } from '../../storages/authStorage';
import { UserAuthApi } from '../v2/UserAuthApi';

const AUTH_API_URL = process.env.REACT_APP_MAIN_API_HOST;

const authAxios = axios.create({
    baseURL: AUTH_API_URL,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
})

let isRefreshing = false, queue = []

authAxios.interceptors.request.use(cfg => {
    const t = getMemoryAccessToken()
    if (t) cfg.headers.Authorization = `Bearer ${t}`
    return cfg
})

authAxios.interceptors.response.use(
    res => res,
    async err => {
        const orig = err.config
        if (err.response?.status === 401 && !orig._retry) {
            orig._retry = true
            if (isRefreshing) {
                return new Promise((res, rej) => queue.push({ res, rej }))
                    .then(newToken => {
                        orig.headers.Authorization = `Bearer ${newToken}`
                        return authAxios(orig)
                    })
            }
            isRefreshing = true
            try {
                const newToken = await UserAuthApi.reissueAccessToken()
                setMemoryAccessToken(newToken)
                queue.forEach(p => p.res(newToken)); queue = []
                orig.headers.Authorization = `Bearer ${newToken}`
                return authAxios(orig)
            } catch (e) {
                queue.forEach(p => p.rej(e)); queue = []
                clearMemoryAccessToken()
                return Promise.reject(e)
            } finally {
                isRefreshing = false
            }
        }
        return Promise.reject(err)
    }
)

export default authAxios
